import { getFormattedToLocale } from 'src/utils/valuesTransformer';

export const countAddonKey = 'Add-Ons';
export const countPlatformKey = 'Platform';
export const yearKey = 'Year';

export const defaultBarConfig = {
  keys: [countAddonKey, countPlatformKey],
  indexBy: yearKey,
  colors: ['rgb(83, 140, 194)', 'rgb(237, 173, 24)'],
  padding: 0.4,
  axisBottom: {
    tickSize: 0,
    tickPadding: 10,
  },
  gridYValues: 5,
  axisLeft: {
    tickValues: 5,
    tickSize: 0,
    tickPadding: 6,
    format: value => getFormattedToLocale(value),
  },
  enableLabel: false,
  theme: {
    fontSize: 14,
    grid: {
      line: {
        stroke: 'rgb(173, 173, 173)',
        strokeWidth: 0.5,
      },
    },
    tooltip: {
      container: {
        fontSize: 14,
      },
    },
  },
};
